import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.CreateSchedulingPoll.title',
    defaultMessage: 'Create Scheduling Poll',
  },
})
